import Navbar from "../components/navbar/Navbar";
import PersHub from "../components/sidePanelComps/PersHub";
import ModelViewer from "../components/mainPageComps/ModelViewer";
import { useSelector } from "react-redux";
import ObjectInterface from "../components/sidePanelComps/ObjectInterface";
import ScreenshotMarkup from "../components/sidePanelComps/ScreenshotMarkup";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useRef } from "react";
import { Spinner } from "react-bootstrap";
import {
  SELECTED_ICON,
  updateNavigationState,
} from "../helpers/reducers/NavigationReducer";

const PersonalHub = () => {
  const { selectedIcon } = useSelector((state) => state.navigationReducer);
  const [viewerState, setViewerState] = useState(null);
  const [mainMarkupPreview, setMainMarkupPreview] = useState(null);
  const [mainMarkupPreviewLoading, setMainMarkupPreviewLoading] = useState(false);
  const dispatch = useDispatch();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current && !selectedIcon) {
      dispatch(
        updateNavigationState({
          value: "File Browser",
          stateName: SELECTED_ICON,
        }),
      );
      initialized.current = true;
    }
  }, [dispatch, selectedIcon]);

  const updateViewerState = (state) => {
    setViewerState(state);
  };

  const updateModelNodes = () => {
    return;
  };

  const updateMarkupExtension = () => {
    return;
  };

  useEffect(() => {
    if (selectedIcon !== "File Browser") {
      setMainMarkupPreview(null);
      setMainMarkupPreviewLoading(false);
    }
  }, [selectedIcon]);

  return (
    <div className="projects-page personal-hub-page">
      <Navbar />

      <div className="container-fluid projects-layout">
        <div className="row projects-row" style={{ height: "93vh" }}>
          <>
            {selectedIcon === "File Browser" && (
              <>
                <div className="col-4 sidebar-panel">
                  <PersHub
                    viewerState={viewerState}
                    onMarkupPreviewSelect={setMainMarkupPreview}
                    onMarkupPreviewLoadingChange={setMainMarkupPreviewLoading}
                  />
                </div>
              </>
            )}
            {selectedIcon === "Properties" && (
              // <SidebarPanel>
              //   <ObjectInterface />
              // </SidebarPanel>
              <>
                <div className="col-4 sidebar-panel">
                  <div className="container" style={{ height: "82vh" }}>
                    <div className="bs-component">
                      <ObjectInterface />
                    </div>
                  </div>
                </div>
              </>
            )}
            {selectedIcon === "Markup" && (
              // <SidebarPanel>
              //   <Markups />
              // </SidebarPanel>
              <>
                <div className="col-4 sidebar-panel">
                  <div className="container" style={{ height: "82vh" }}>
                    <div className="bs-component">
                      <ScreenshotMarkup
                        viewerState={viewerState}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
          <div
            className="col projects-content-col"
            style={{ padding: "0 0.35rem" }}
          >
            <div
              className="projects-content-shell"
              style={{ position: "relative", height: "100%", width: "100%" }}
            >
              {selectedIcon === "File Browser" && mainMarkupPreviewLoading ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "18px",
                    overflow: "hidden",
                  }}
                >
                  <div className="loading-modal" style={{ width: "100%" }}>
                    <div className="modal-content" style={{ maxWidth: "420px", margin: "0 auto" }}>
                      <div className="loading-modal__body">
                        <div className="text-center loading-modal__content">
                          <h4 className="loading-modal__title">
                            Loading Markup...
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              className="loading-modal__spinner"
                            />
                          </h4>
                          <p className="loading-modal__copy" style={{ marginBottom: 0 }}>
                            Please wait while the full markup is loading.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : selectedIcon === "File Browser" && mainMarkupPreview?.image ? (
                <div
                  style={{
                    position: "relative",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#111",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={mainMarkupPreview.image}
                    alt={mainMarkupPreview.title || "Markup preview"}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              ) : (
                <ModelViewer
                  updateViewerState={updateViewerState}
                  updateModelNodes={updateModelNodes}
                  updateMarkupExtension={updateMarkupExtension}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalHub;
